module.exports = __webpack_public_path__ + "static/media/How to create document checklist.7438788b.png";